package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import kotlinx.serialization.Serializable

@Stable
@Serializable
sealed interface AuthUser {
    data object Unknown : AuthUser

    @Serializable
    @Stable
    data class User(
        val displayName: String? = null,
        val email: String? = null,
        val photoUrl: String? = null,
        val uid: String,
    ) : AuthUser
}
